import { AgGridConfig } from '@approot/models';
import { Header } from '@approot/models/ag-grid.model';
import { ColDef, ColumnApi, ColumnState } from 'ag-grid-community';

export function applyColumnState(
  columnApi: ColumnApi,
  columnState: ColumnState[]
) {
  try {
    columnApi.applyColumnState({
      state: columnState,
      applyOrder: true
    });
  } catch (e) {
    console.error('Unable to load column state', e);
  }
}

export function mapHeaders(setting: AgGridConfig, globalDef: AgGridConfig) {
  const defaultHeaders = globalDef.headers as Header[];
  const settingHeaders = setting.headers as string[];
  return settingHeaders.map(headerName => {
    return defaultHeaders.find(header => header.field === headerName);
  });
}

export function setColumnsColors(headers: ColDef[]): void {
  headers.forEach((header: ColDef) => {
    header.cellStyle = params => {
      if (params.node?.rowPinned === 'bottom') {
        return {
          color:
            params.value < 0 ? 'var(--negative-red)' : 'var(--positive-green)',
          fontWeight: 'bold',
          fontSize: '0.7rem'
        };
      } else if (params.node?.footer) {
        return {
          color: 'var(--label-grey)'
        };
      } else {
        if (typeof params.value !== 'number') {
          return {
            color: 'white'
          };
        } else {
          return {
            color:
              params.value < 0 ? 'var(--negative-red)' : 'var(--positive-green)'
          };
        }
      }
    };
  });
}
